import React, { useState } from 'react';

/**
 * Плавающая кнопка для тестирования отправки изображений
 */
const FloatingShareButton = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [messageId, setMessageId] = useState('');
    const [status, setStatus] = useState(null);

    const handleShare = async () => {
        if (!messageId) {
            setStatus({ type: 'error', message: 'Введите ID сообщения' });
            return;
        }

        if (!window.Telegram?.WebApp) {
            setStatus({ type: 'error', message: 'Telegram WebApp не доступен' });
            return;
        }

        try {
            setStatus({ type: 'info', message: 'Открываем диалог отправки...' });
            
            // Вызываем shareMessage с готовым ID от бота
            window.Telegram.WebApp.shareMessage(messageId, (success) => {
                if (success) {
                    setStatus({ type: 'success', message: '🎉 Изображение успешно отправлено!' });
                } else {
                    setStatus({ type: 'info', message: '📤 Отправка отменена' });
                }
            });
            
        } catch (error) {
            setStatus({ type: 'error', message: `Ошибка: ${error.message}` });
        }
    };

    return (
        <div className="fixed bottom-20 right-4 z-50">
            {/* Плавающая кнопка */}
            <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="bg-blue-500 hover:bg-blue-600 text-white p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110"
                title="Тест отправки изображений"
            >
                {isExpanded ? '✕' : '📤'}
            </button>

            {/* Развернутая панель */}
            {isExpanded && (
                <div className="absolute bottom-16 right-0 bg-white rounded-lg shadow-xl p-4 w-80 border">
                    <h3 className="font-semibold mb-3 text-gray-800">📤 Тест shareMessage()</h3>
                    
                    {/* Поле для ввода ID сообщения */}
                    <div className="mb-3">
                        <label className="block text-sm font-medium mb-2">ID сообщения от бота:</label>
                        <input
                            type="text"
                            value={messageId}
                            onChange={(e) => setMessageId(e.target.value)}
                            placeholder="wRhEzPCLmLc0XCX2"
                            className="w-full p-2 border rounded-lg text-sm"
                        />
                        <p className="text-xs text-gray-500 mt-1">
                            Получите ID от бота командой /test_share или /post_channel
                        </p>
                    </div>
                    
                    {/* Кнопка отправки */}
                    <button
                        onClick={handleShare}
                        disabled={!messageId}
                        className="w-full bg-green-500 hover:bg-green-600 disabled:bg-gray-400 text-white py-2 px-4 rounded-lg transition-colors"
                    >
                        📤 Вызвать shareMessage()
                    </button>
                    
                    {/* Статус */}
                    {status && (
                        <div className={`mt-3 p-2 rounded text-sm ${
                            status.type === 'success' ? 'bg-green-100 text-green-800' :
                            status.type === 'error' ? 'bg-red-100 text-red-800' :
                            'bg-blue-100 text-blue-800'
                        }`}>
                            {status.message}
                        </div>
                    )}
                    
                    {/* Инструкция */}
                    <div className="mt-3 text-xs text-gray-500">
                        <p><strong>Вариант 1 (личное сообщение):</strong></p>
                        <p>1. Отправьте боту /test_share</p>
                        <p>2. Скопируйте ID из ответа</p>
                        <p><strong>Вариант 2 (из канала):</strong></p>
                        <p>1. Отправьте боту /post_channel</p>
                        <p>2. Скопируйте ID из канала</p>
                        <p>3. Вставьте ID и нажмите кнопку</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FloatingShareButton;
